import PropTypes from 'prop-types';
import {renderMarkdown} from 'helpers/text-helper';
import Audio from 'components/ui/audio/audio';
import './task-intro.scss';

const TaskIntro = (props) => {
	/* Props */
	const {
		text, 
		selectOptionsText,
		image, 
		fileName,
		deviceInfo
	} = props;

	return (
		<div className={'TaskIntro' + (image ? ' ' + image : '') + ' ' + deviceInfo.orientation}>
			<div className="TaskIntro-text">
				{text && renderMarkdown(text)}
				{selectOptionsText && <span>{selectOptionsText}</span>}
			</div>
			{image && <div className="TaskIntro-image" />}
			<div className="TaskIntro-audio">
				<Audio 
					type='task-intro'
					color="blue"
					fileName={fileName}
				/>
			</div>
		</div>
	);
};

TaskIntro.propTypes = {
	fileName: PropTypes.string.isRequired,
	text: PropTypes.string,
	selectOptionsText: PropTypes.string,
	image: PropTypes.string,
	deviceInfo: PropTypes.object.isRequired,
};

export default TaskIntro;
